export const navs = [
    { name: "Home", url: "/home" },
    { name: "About", url: "/home#about" },
    { name: "Services", url: "/home#services", template: true },
    { name: "Certifications", url: "/home#certifications" },
    { name: "Gallery", url: "/home#gallery" },
    { name: "Contact Us", url: "/home#contact" },
];
